import WidgetNotebookEdit from '@/views/counteragents/counteragent-card/widgets/widget-notebook-ge.vue';
import WidgetEmployeeEdit from '@/views/counteragents/counteragent-card/widgets/widget-employee.vue';
import WidgetDopOkvedEdit from '@/views/counteragents/counteragent-card/widgets/widget-dop-okved.vue';
import { markRaw } from 'vue';

const list = [
    {
        name: 'Записная книжка',
        icon: '/infoenergo/assets/contract.svg',
        component: WidgetNotebookEdit,
    },
    {
        name: 'Должностные лица',
        icon: '/infoenergo/assets/contract.svg',
        component: WidgetEmployeeEdit,
    },
    {
        name: 'Дополнительные ОКВЭД',
        icon: '/infoenergo/assets/contract.svg',
        component: WidgetDopOkvedEdit,
    },
];

const useCounteragentWidgetList = () => {
    return list.map(widget => {
        const { component, ...rest } = widget;
        return {
            ...rest,
            id: 'widget-' + Math.floor(Math.random() * Date.now()).toString(),
            visible: false,
            component: markRaw(component),
        };
    });
};

export default useCounteragentWidgetList;
